/**
 * @generated SignedSource<<ed4f957a9d3632cb1117f3b7c5b1ad09>>
 * @relayHash 2b953275ff0f23f9e172aa04b7c1d256
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f5fc9fa4e14ab89f747e76c10fa4beb91821ecc594bd03e52db1c714dd95ffcd

import type { ConcreteRequest } from 'relay-runtime';
export type ProjectCapabilitiesQuery$variables = {
  containerId: string;
  isM3GroupPermsEnabled: boolean;
};
export type ProjectCapabilitiesQuery$data = {
  readonly projects_capabilities?: {
    readonly canCreateProject: boolean | null;
    readonly canCreateUpdates: boolean | null;
    readonly canExportProjects: boolean | null;
  } | null;
};
export type ProjectCapabilitiesQuery = {
  response: ProjectCapabilitiesQuery$data;
  variables: ProjectCapabilitiesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "containerId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isM3GroupPermsEnabled"
  }
],
v1 = [
  {
    "condition": "isM3GroupPermsEnabled",
    "kind": "Condition",
    "passingValue": true,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "containerId",
            "variableName": "containerId"
          }
        ],
        "concreteType": "TownsquareProjectAppCapabilities",
        "kind": "LinkedField",
        "name": "projects_capabilities",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "canCreateProject"
          },
          {
            "kind": "ScalarField",
            "name": "canCreateUpdates"
          },
          {
            "kind": "ScalarField",
            "name": "canExportProjects"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ProjectCapabilitiesQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProjectCapabilitiesQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "f5fc9fa4e14ab89f747e76c10fa4beb91821ecc594bd03e52db1c714dd95ffcd",
    "metadata": {},
    "name": "ProjectCapabilitiesQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "997a8cee21c49c767f216ddd971f9e49";

export default node;
